import {Toggle} from '@fluentui/react';
import React, {useState} from 'react';
import styles from './List.module.scss';

interface ICustomProcessToggle<T> {
  changedItems: T[] | undefined;
  setTableTouched?: React.Dispatch<React.SetStateAction<boolean>>;
  tableTouched?: boolean;
  item: T;
  property: 'removed' | 'active' | 'auditable' | 'checkedAcknowledgementItem';
  mapToClass: (value: {[key: string]: any}) => T;
}

export const CustomProcessToggle = <
  T extends {
    id: number;
    active?: boolean;
    removed?: boolean;
    auditable?: boolean;
    checkedAcknowledgementItem?: boolean;
  }
>({
  changedItems,
  setTableTouched,
  tableTouched,
  item,
  property,
  mapToClass
}: ICustomProcessToggle<T>) => {
  const [value, setValue] = useState<boolean | undefined>((item as {[key: string]: any})[property]);
  if (!changedItems) return <></>;
  const className = value ? styles[property] : '';
  return (
    <Toggle
      className={`${styles.toggle} ${className}`}
      defaultChecked={item[property]}
      onChange={(e, checked) => {
        setValue(checked);
        if (tableTouched !== undefined && setTableTouched !== undefined) {
            setTableTouched(!tableTouched); 
        }
        const changedElements = changedItems.filter(element => element.id === item.id)[0];
        if (changedElements) {
          changedElements[property] = !!checked;
        } else {
          changedItems.push(mapToClass({...item, [property]: !!checked}));
        }
      }}
    />
  );
};
